import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/IMG_4242.PNG";

// Mascot + wordmark. `to` makes it a home link.
const Logo = ({ className = "w-10 h-10", to }) => {
  const img = (
    <img
      src={logo}
      alt="تربع"
      className={`object-contain drop-shadow ${className}`}
      draggable={false}
    />
  );
  if (!to) return img;
  return (
    <Link to={to} className="inline-flex items-center" aria-label="تربع، الصفحة الرئيسية">
      {img}
    </Link>
  );
};

export default Logo;
